import React from 'react';
import { useSelector } from 'react-redux';
import {Routes} from "../../../routes";
import {useHistory} from "react-router-dom";
import ProductList from "../../components/Product/ProductList";
//import ProductList from "../../components/Product/ProductList";
// eslint-disable-next-line react-hooks/rules-of-hooks


function ProductPage() {
    const navigate = useHistory();
    const ciemId = useSelector(state => state.ciem.ciemId);
    if(!ciemId){
        alert("Para ingresar a esta opcion debe seleccionar una idea de negocio");
        //console.log("no tiene ciem")
        navigate.push(Routes.ListCiemPage.path);
    }
    return (
        <div>
            <ProductList ciemId={ciemId}/>
        </div>
    );
}

export default ProductPage;